/**
 * Enumeration of custom event names that are emitted by the components.
 */
export const BpEventType = {
  Error: "bp:error",
} as const;

export type BpEventType = (typeof BpEventType)[keyof typeof BpEventType];

/**
 * Emit a custom event to the document to be handled by the host application.
 */
export function emitEvent(type: BpEventType, detail: Record<string, unknown>) {
  globalThis.document?.dispatchEvent(
    new CustomEvent(type, {
      detail,
    }),
  );
}

/**
 * Emit a custom `bp:error` event.
 */
export function emitError(detail: Record<string, unknown>) {
  emitEvent(BpEventType.Error, detail);
}
